import { EnvVarsService } from '@multitenancy-spa/env-vars-service/esm/services/env-vars-service';

function pickKeysStartingWith<T extends object>(
	obj: T,
	prefix: string,
): Partial<T> {
	return Object.fromEntries(
		Object.entries(obj).filter(([key]) => key.startsWith(prefix)),
	) as Partial<T>;
}

const queryStringEnvVars = Object.fromEntries(
	new URLSearchParams(globalThis.location.search).entries(),
);

EnvVarsService.vars = {
	...pickKeysStartingWith(import.meta.env, 'VITE_'),
	...queryStringEnvVars,
};
